import { API, graphqlOperation } from 'aws-amplify';

const fetch = (query, params) => {
    return API.graphql(graphqlOperation(query, params))
        // if (res.data?.RestaurantByOrder?.items) {
        //     result = res.data.RestaurantByOrder.items
        // }
            
        // .then((response) => {
        //     console.log('response', response);
        //     dispatch(success(response.data.RestaurantByOrder.items))
        // }).catch((response) => {
        //     console.log('error', response);
        //     // dispatch(failure(response.data.message));
        // });
    // } catch (err) {
    //     console.error('getRestaurantes', err)
    //     // data = err.data;
    //     // errors = err.errors;
    //     // dispatch(failure(err));
    // }
    // return result
}

const fetchAll = async(query, params, limit = 50, maxPages = 10) => {
    const response = { data: [], hasMoreData: false, nextToken: null }
    let queryParams = { ...params, nextToken: null }
    let page = 0;
    do {
        page++;
        const pageData = await API.graphql(graphqlOperation(query, queryParams))
        if (pageData.data) {
            const _data = pageData.data[Object.keys(pageData.data)[0]];
            queryParams.nextToken = _data.nextToken || null;
            response['data'] = [ ...response['data'], ..._data.items ];
        } else {
            queryParams.nextToken = null;
        }
        response["hasMoreData"] = Boolean(queryParams.nextToken);
        response["nextToken"] = queryParams.nextToken;
    } while (queryParams.nextToken && response.data.length < limit && page < maxPages)
    return response;
}

export {
    fetch,
    fetchAll
}